import { formatQueryParams } from '@cmd/ui-utilities';
const generateNvisionAnalyzeLeadsUrl = () => {
    const { environment, } = window.cmdContainer || {};
    return `https://nvision${environment === 'prod'
        ? ''
        : '-qa'}.coxautoinc.com/analytics/report/analyze-leads`;
};
const ANALYZE_LEADS_TABLE_ID = 'leadsTable';
export const getNvisionAnalyzeLeadsUrl = (dateRange, linkToTable = false) => {
    const url = `${generateNvisionAnalyzeLeadsUrl()}?${formatQueryParams(dateRange)}`;
    return `${url}${linkToTable ? `#${ANALYZE_LEADS_TABLE_ID}` : ''}`;
};
export default {
    getNvisionAnalyzeLeadsUrl,
};
